import { DOCUMENT } from '@angular/common';
import { Component, Inject, OnDestroy, OnInit, Renderer2 } from '@angular/core';

import {Router} from '@angular/router';
import {RestapiService} from '../restapi.service';
import { saveAs } from 'file-saver';

@Component({
  selector: 'app-flash-report',
  templateUrl: './flash-report.component.html',
  styleUrls: ['./flash-report.component.css']
})
export class FlashReportComponent implements OnInit {
	respObject: any;
	fileData: any;
  compObj: any;
  compData: any;

  dataType = "";
  fileYear="";
  fullYear: number = new Date().getFullYear();
  yearArr= [];
  yearfArr= [];
  filefYear="";
  selectMonth="";
  fileQuarter="";
  companyId="";
  company="";
  companyName="";
  downLoadPath=this._rest.FILE_PATH;
  userRole=localStorage.getItem('userRole');

  perPageRow = this._rest.PER_PAGE_ROW+50;
  curPage = 1;
  totalRows = 0;
  pages = [];
  noOfRows=0;
  constructor(@Inject(DOCUMENT) private document: Document,
        private renderer: Renderer2,private router: Router, private _rest: RestapiService) { }

  ngOnInit(): void {
    
    this.selectMonth="";
   
    this.curPage= 1;
    for (var i= this.fullYear-10;i<=this.fullYear;i++){
      this.yearArr.push(i);
      //this.fileYear= i+"";
    }
    
    const cRData = {}
    this.companyId = localStorage.getItem('companyId');
   
    this._rest.companyList(cRData).subscribe((res) => {
      this.compObj = res;
      this.compData = this.compObj.details; 
     
	      for (let i=0;i<this.compData.length;i++){
	      	if(this.compData[i].companyId==this.companyId){
	      		this.companyName = this.compData[i].companyName;
	      		break;
	      	}
	      }  
	   
    });
    this.searchFile(1);
  	/*const data = {}
  	this._rest.getAdminFiles(data).subscribe((res) => {
  		this.respObject = res;
  		if(this.respObject.error==0){
  			this.fileData=this.respObject.resp;
  		}
  		console.log(JSON.stringify(this.respObject));
  	})*/
  }
  searchFile(curPage){
    this.curPage = curPage;
    var fd = {};
    
    fd["limit"]=this.perPageRow;
    fd["page"]=this.curPage;
    fd["year"]=this.fileYear;
    fd["month"]=this.selectMonth;
    if(this.companyId!=""){
      fd["companyId"]=this.companyId;
    }
    console.log(fd);
    this._rest.flashReport(fd).subscribe((res) => {
      this.respObject = res;
      if(this.respObject.error==0){
        this.fileData=this.respObject.resp.data;
        this.totalRows = this.respObject.resp.info;
        this.noOfRows=this.fileData.length;
        this.pages=[];
        for (var i=1;i<=Math.ceil(this.totalRows/this.perPageRow);i++){
          this.pages.push(i);
        }
      } else {
        this.fileData=[];
        this.totalRows = 0;
        this.noOfRows = 0;
        this.pages=[];
      }
    })
  }

  chngCompId(){
  	this.companyId=this.company;
  }
  goFileDetailsPage(fdata){
  	if(this.companyName==""){
  		this.router.navigate(['/admin/flashReportView/',fdata.month,fdata.year]);
  	} else {
      if (this.userRole=="compliance") {
          this.router.navigate(['/compliance/flashReportView/',fdata.month,fdata.year]);
      }else{
          this.router.navigate(['/analyst/flashReportView/',fdata.month,fdata.year]);
      }
  	}
  }
  downloadFile(fdata){
  	console.log(this.downLoadPath+"report/Flash_"+fdata.month+"_"+fdata.year+".xlsx");
  	saveAs(this.downLoadPath+"report/Flash_"+fdata.month+"_"+fdata.year+".xlsx", "Flash_"+fdata.month+"_"+fdata.year+".xlsx");
  }
}


